import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08efc9c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header__left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__separator" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "header__left-teleport-container" }, null, -1))
const _hoisted_6 = { class: "header__right" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "header__right-teleport-container" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "header__user"
}
const _hoisted_9 = {
  key: 1,
  class: "header__links"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://qodex.tech/project",
  class: "header__link"
}, " О проекте ", -1))

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import QHeaderUser from './QHeaderUser.vue'
import QHeaderSupport from './QHeaderSupport.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

const pageTitle = computed(() => route.meta.routeTitle)
const isUserAuth = computed(() => route.meta.isAuth)
const pageTheme = computed(() => route.meta.pageTheme === 'dark' ? true : false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", _ctx.$route.name, {hideRight: _ctx.$route.meta.routeTitle === 'Не найдено'}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "header__logo",
          src: require(`@/assets/images/logoo-${_unref(pageTheme) ? 'w' : 'b'}.svg`),
          alt: "Логотип",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
        }, null, 8, _hoisted_3),
        _hoisted_4,
        _createElementVNode("div", {
          class: _normalizeClass(["header__page-title", {'header__page-title--light': _unref(pageTheme)}])
        }, _toDisplayString(_unref(pageTitle)), 3),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        (_unref(isUserAuth))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(QHeaderSupport),
              _createVNode(QHeaderUser)
            ]))
          : _createCommentVNode("", true),
        (!_unref(isUserAuth))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(QHeaderSupport, { text: "" })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})